module.exports = __webpack_public_path__ + "static/media/building.9f38bf85.svg";